"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var BaseModel_1 = require("./BaseModel");
var RoleResponse;
(function (RoleResponse) {
    var Role = (function (_super) {
        __extends(Role, _super);
        function Role() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.id = undefined;
            _this.userRole = undefined;
            return _this;
        }
        return Role;
    }(BaseModel_1["default"]));
    RoleResponse.Role = Role;
})(RoleResponse = exports.RoleResponse || (exports.RoleResponse = {}));



//////////////////
// WEBPACK FOOTER
// ../model/dist/models/role.js
// module id = ../model/dist/models/role.js
// module chunks = main